(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel-collection"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var collectionCarousels = document.querySelectorAll('[data-carousel="collection"]');

    collectionCarousels.forEach(function (carousel) {
      var el = carousel.querySelector('[data-carousel="element"]');
      if (!el) return;

      var autoplay = el.getAttribute('data-autoplay') === 'true';
      var duration = parseInt(el.getAttribute('data-duration')) || 2500;
      var pause = el.getAttribute('data-pause') === 'true';
      var nextButton = carousel.querySelector('[data-next]');
      var prevButton = carousel.querySelector('[data-prev]');
      var progressbar = carousel.querySelector('[data-progressbar]');

      var swiperOptions = {
        slidesPerView: 'auto',
        spaceBetween: 10,
        loop: false,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        scrollbar: {
          el: progressbar,
          draggable: true,
        },
      };

      if (autoplay) {
        swiperOptions.autoplay = {
          delay: duration,
          pauseOnMouseEnter: pause,
          disableOnInteraction: true,
          stopOnLastSlide: true,
        };
      }

      var collectionSwiper = new Swiper(el, swiperOptions);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel-hero"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var collectionCarousels = document.querySelectorAll('[data-carousel="hero"]');

    if (collectionCarousels.length === 0) {
      return;
    }

    collectionCarousels.forEach(function (carousel) {
      var siteHeader = document.querySelector('.site-header');
      if (siteHeader && carousel.getAttribute('data-header-transparent') === 'true') {
        siteHeader.classList.add('is-transparent');
        siteHeader.classList.add('absolute');
        siteHeader.classList.add('top-0');
        siteHeader.classList.add('left-0');
        siteHeader.classList.add('right-0');

        carousel.parentElement.style.setProperty('--header-height', siteHeader.offsetHeight + 'px');

        // Update header height on window resize
        var updateHeaderHeight = function () {
          if (siteHeader) {
            carousel.parentElement.style.setProperty('--header-height', siteHeader.offsetHeight + 'px');
          }
        };

        window.addEventListener('resize', updateHeaderHeight);
      } else if (siteHeader) {
        siteHeader.classList.remove('is-transparent');
      }

      var el = carousel.querySelector('[data-carousel="element"]');
      if (!el) return;

      var autoplay = el.getAttribute('data-autoplay') === 'true';
      var duration = parseInt(el.getAttribute('data-duration')) || 2500;
      var pause = el.getAttribute('data-pause') === 'true';
      var progressbar = carousel.querySelector('[data-progressbar]');

      function setEqualSlideHeights() {
        var slides = el.querySelectorAll('.swiper-slide');
        var maxHeight = 0;

        // Reset heights to auto to get natural height
        slides.forEach(function (slide) {
          slide.style.height = 'auto';
        });

        // Find the tallest slide
        slides.forEach(function (slide) {
          var slideHeight = slide.offsetHeight;
          if (slideHeight > maxHeight) {
            maxHeight = slideHeight;
          }
        });

        // Set all slides to the maximum height
        slides.forEach(function (slide) {
          slide.style.setProperty('--height', maxHeight + 'px');
        });
      }

      var swiperOptions = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        scrollbar: {
          el: progressbar,
          draggable: true,
        },
        on: {
          init: function () {
            setEqualSlideHeights();
          },
          resize: function () {
            setEqualSlideHeights();
          },
        },
      };

      if (autoplay) {
        swiperOptions.autoplay = {
          delay: duration,
          pauseOnMouseEnter: pause,
          disableOnInteraction: true,
          stopOnLastSlide: true,
        };
      }

      var collectionSwiper = new Swiper(el, swiperOptions);

      // Also handle window resize events
      window.addEventListener('resize', function () {
        setTimeout(function () {
          setEqualSlideHeights();
        }, 100);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel-post-rss"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const postCarousels = document.querySelectorAll('[data-carousel="post-rss"]');
    const templateNode = document.querySelector('#rss-card-template');

    if (!templateNode) {
      console.error('RSS card template not found!');
      return;
    }
    const postTemplate = templateNode.innerHTML;

    postCarousels.forEach(async (carousel) => {
      const el = carousel.querySelector('[data-carousel="element"]');
      const swiperWrapper = el.querySelector('.swiper-wrapper');
      const rssUrl = carousel.dataset.rssUrl;
      const limit = parseInt(carousel.dataset.limit, 10);
      const readMoreLabel = carousel.dataset.readMoreLabel;

      if (!rssUrl || !swiperWrapper) return;

      try {
        const response = await fetch(rssUrl);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const str = await response.text();
        const data = new window.DOMParser().parseFromString(str, 'text/xml');
        const items = Array.from(data.querySelectorAll('item')).slice(0, limit);

        let slidesHtml = '';
        for (const item of items) {
          const title = item.querySelector('title')?.textContent || '';
          const link = item.querySelector('link')?.textContent || '#';
          const description = item.querySelector('description')?.textContent || '';

          // Find image: first from media:content, then from inside description
          let imageUrl =
            item.querySelector('media\\:content')?.getAttribute('url') || '{{ "image-placeholder.png" | asset_url }}';
          if (imageUrl === '{{ "image-placeholder.png" | asset_url }}') {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = description;
            const img = tempDiv.querySelector('img');
            if (img) imageUrl = img.src;
          }

          // Create a clean excerpt
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = description;
          const excerpt = (tempDiv.textContent || tempDiv.innerText || '').substring(0, 150) + '...';

          // Populate the template
          const slideHtml = postTemplate
            .replace(/%%URL%%/g, link)
            .replace(/%%TITLE%%/g, title.replace(/"/g, '&quot;'))
            .replace(/%%IMAGE_URL%%/g, imageUrl)
            .replace(/%%EXCERPT%%/g, excerpt)
            .replace(/%%READ_MORE%%/g, readMoreLabel);

          slidesHtml += slideHtml;
        }

        swiperWrapper.innerHTML = slidesHtml;
      } catch (error) {
        console.error('Error fetching or parsing RSS feed:', error);
        swiperWrapper.innerHTML = `<p class="p-4">Failed to load blog posts.</p>`;
      }

      // Initialize Swiper using original script's logic
      const autoplay = el.getAttribute('data-autoplay') === 'true';
      const duration = parseInt(el.getAttribute('data-duration')) || 2500;
      const pause = el.getAttribute('data-pause') === 'true';
      const nextButton = carousel.querySelector('[data-next]');
      const prevButton = carousel.querySelector('[data-prev]');
      const progressbar = carousel.querySelector('[data-progressbar]');

      const swiperOptions = {
        slidesPerView: 'auto',
        spaceBetween: 10,
        loop: false,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        scrollbar: {
          el: progressbar,
          draggable: true,
        },
      };

      if (autoplay) {
        swiperOptions.autoplay = {
          delay: duration,
          pauseOnMouseEnter: pause,
          disableOnInteraction: true,
          stopOnLastSlide: true,
        };
      }
      new Swiper(el, swiperOptions);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel-post"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var postCarousels = document.querySelectorAll('[data-carousel="post"]');

    postCarousels.forEach(function (carousel) {
      var el = carousel.querySelector('[data-carousel="element"]');
      if (!el) return;

      var autoplay = el.getAttribute('data-autoplay') === 'true';
      var duration = parseInt(el.getAttribute('data-duration')) || 2500;
      var pause = el.getAttribute('data-pause') === 'true';
      var nextButton = carousel.querySelector('[data-next]');
      var prevButton = carousel.querySelector('[data-prev]');
      var pagination = carousel.querySelector('[data-pagination]');
      var progressbar = carousel.querySelector('[data-progressbar]');

      var swiperOptions = {
        slidesPerView: 'auto',
        spaceBetween: 10,
        loop: false,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        scrollbar: {
          el: progressbar,
          draggable: true,
        },
      };

      if (autoplay) {
        swiperOptions.autoplay = {
          delay: duration,
          pauseOnMouseEnter: pause,
          disableOnInteraction: true,
          stopOnLastSlide: true,
        };
      }

      var postSwiper = new Swiper(el, swiperOptions);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel-product"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var productCarousels = document.querySelectorAll('[data-carousel="product"]');

    productCarousels.forEach(function (carousel) {
      var el = carousel.querySelector('[data-carousel="element"]');
      if (!el) return;

      var autoplay = el.getAttribute('data-autoplay') === 'true';
      var duration = parseInt(el.getAttribute('data-duration')) || 2500;
      var pause = el.getAttribute('data-pause') === 'true';
      var nextButton = carousel.querySelector('[data-next]');
      var prevButton = carousel.querySelector('[data-prev]');
      var pagination = carousel.querySelector('[data-pagination]');
      var progressbar = carousel.querySelector('[data-progressbar]');

      var swiperOptions = {
        slidesPerView: 'auto',
        spaceBetween: 10,
        loop: false,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        scrollbar: {
          el: progressbar,
          draggable: true,
        },
      };

      if (autoplay) {
        swiperOptions.autoplay = {
          delay: duration,
          pauseOnMouseEnter: pause,
          disableOnInteraction: true,
          stopOnLastSlide: true,
        };
      }

      var productSwiper = new Swiper(el, swiperOptions);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel-tabs"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var tabs = document.querySelectorAll('[data-tab="carousel"]');
    if (tabs) {
      tabs.forEach(function (tab) {
        var tabButtons = tab.querySelectorAll('[data-tab]');
        var tabContent = tab.querySelectorAll('[data-tab-id]');
        if (tabButtons.length) {
          tabButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
              tabContent.forEach(function (t) {
                t.classList.remove('is-active');
              });
              var tabId = e.currentTarget.getAttribute('data-tab');
              tabButtons.forEach(function (btn) {
                if (btn.getAttribute('data-tab') === tabId) {
                  btn.classList.add('is-current');
                } else {
                  btn.classList.remove('is-current');
                }
              });

              var activeTab = tab.querySelector('[data-tab-id="' + tabId + '"]');
              if (activeTab) {
                activeTab.classList.add('is-active');
              }
            });
          });
        }
      });
    }

    var productCarousels = document.querySelectorAll('[data-carousel="product"]');

    productCarousels.forEach(function (carousel) {
      var el = carousel.querySelector('[data-carousel="element"]');
      if (!el) return;

      var autoplay = el.getAttribute('data-autoplay') === 'true';
      var duration = parseInt(el.getAttribute('data-duration')) || 2500;
      var pause = el.getAttribute('data-pause') === 'true';
      var nextButton = carousel.querySelector('[data-next]');
      var prevButton = carousel.querySelector('[data-prev]');
      var pagination = carousel.querySelector('[data-pagination]');
      var progressbar = carousel.querySelector('[data-progressbar]');

      var swiperOptions = {
        slidesPerView: 'auto',
        spaceBetween: 10,
        loop: false,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        scrollbar: {
          el: progressbar,
          draggable: true,
        },
      };

      if (autoplay) {
        swiperOptions.autoplay = {
          delay: duration,
          pauseOnMouseEnter: pause,
          disableOnInteraction: true,
          stopOnLastSlide: true,
        };
      }

      var productSwiper = new Swiper(el, swiperOptions);
    });

    // --- Replaced auto tab switching: progress-based thresholds ---
    var AUTO_DELAY = 500; // ms delay between switches
    var lastAutoSwitch = 0;

    var carouselTabContainers = document.querySelectorAll('[data-tab="carousel"]');

    carouselTabContainers.forEach(function (container) {
      var tabContentBlocks = Array.prototype.slice.call(container.querySelectorAll('[data-tab-id]'));
      var tabIds = tabContentBlocks.map(function (el) {
        return el.getAttribute('data-tab-id');
      });
      if (!tabIds.length) return;

      // Track last index per container
      container._lastIndex = (function () {
        for (var i = 0; i < tabContentBlocks.length; i++) {
          if (tabContentBlocks[i].classList.contains('is-active')) return i;
        }
        return 0;
      })();

      function activateByIndex(index) {
        if (index < 0 || index >= tabIds.length) return;
        if (index === container._lastIndex) return;
        var now = Date.now();
        if (now - lastAutoSwitch < AUTO_DELAY) return;
        var targetId = tabIds[index];
        var btn = container.querySelector('[data-tab="' + targetId + '"]');
        if (btn) {
          btn.click();
          container._lastIndex = index;
          lastAutoSwitch = now;
        }
      }

      // Manual click sync
      container.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-tab]');
        if (!btn) return;
        var id = btn.getAttribute('data-tab');
        var idx = tabIds.indexOf(id);
        if (idx !== -1) {
          container._lastIndex = idx;
          lastAutoSwitch = Date.now();
        }
      });

      function inViewport(rect, vh) {
        // Require some part visible
        return rect.bottom > 0 && rect.top < vh;
      }

      function updateByScroll() {
        var rect = container.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (!inViewport(rect, vh)) return;

        var sectionHeight = rect.height || 1;
        var viewportMid = vh / 2;
        var progress = (viewportMid - rect.top) / sectionHeight;
        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;

        var segments = tabIds.length;
        // Determine index based on equal fractional segments
        var rawIndex = Math.floor(progress * segments);
        if (rawIndex === segments) rawIndex = segments - 1; // clamp edge
        activateByIndex(rawIndex);
      }

      // Use rAF throttle
      var ticking = false;
      function onScroll() {
        if (!ticking) {
          requestAnimationFrame(function () {
            updateByScroll();
            ticking = false;
          });
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      // Initial call
      updateByScroll();
    });
    // --- End progress-based auto tab switching ---
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function sideCartScripts() {
      var cartSection = document.querySelector('[data-ajax-cart-section]');
      var overlay = document.querySelector('[data-ajax-cart-overlay]');
      var closeButton = document.querySelector('[data-ajax-cart-close]');

      // Close side cart when clicking outside
      document.body.addEventListener('click', function (event) {
        if (event.target.matches('[data-ajax-cart-toggle]')) {
          event.preventDefault();
          document.body.classList.toggle('is-sidecart-open');
        }
      });

      // Toggle side cart visibility
      if (overlay) {
        overlay.addEventListener('click', function () {
          document.body.classList.remove('is-sidecart-open');
        });
      }
      if (closeButton) {
        closeButton.addEventListener('click', function () {
          document.body.classList.remove('is-sidecart-open');
        });
      }

      // Add loading state to Add to Cart button when form is submitted
      var addToCartBtn = document.querySelectorAll('[data-add-to-cart]');
      var showSidecart = false;
      if (addToCartBtn) {
        addToCartBtn.forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            if (!window.liquidAjaxCart?.init) return;
            // Ignore the click if Liquid Ajax Cart is processing a request
            if (window.liquidAjaxCart.processing) return;
            e.currentTarget.classList.add('is-cart-processing');
            showSidecart = true;
          });

          // Remove loading state when Ajax Cart request ends
          document.addEventListener('liquid-ajax-cart:request-end', function () {
            btn.classList.remove('is-cart-processing');
          });
        });
      }
    }
    sideCartScripts();
    document.addEventListener('liquid-ajax-cart:queue-end', function () {
      sideCartScripts();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('change', function (e) {
    const form = document.getElementById('CollectionFiltersForm');
    if (!form) return;
    if (form.contains(e.target) && e.target.type === 'checkbox') {
      form.submit();
    }
  });
  let priceTimeout;
  document.querySelectorAll('#CollectionFiltersForm [name*="filter.v.price"]').forEach(function (inp) {
    inp.addEventListener('input', function () {
      clearTimeout(priceTimeout);
      priceTimeout = setTimeout(function () {
        const form = document.getElementById('CollectionFiltersForm');
        if (form) form.submit();
      }, 600);
    });
  });
  // Updated sort handler: sync hidden input then submit form
  (function () {
    var sortSel = document.querySelector('[data-collection-sort]');
    if (!sortSel) return;
    var form = document.getElementById('CollectionFiltersForm');
    if (!form) return;
    var hidden = form.querySelector('#SortByInput');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'sort_by';
      hidden.id = 'SortByInput';
      form.appendChild(hidden);
    }
    sortSel.addEventListener('change', function () {
      if (this.value === 'best-selling') {
        hidden.value = '';
        hidden.disabled = true; // omit param for default
      } else {
        hidden.disabled = false;
        hidden.value = this.value;
      }
      // remove page param from URL before submit (so it resets to page 1)
      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      window.history.replaceState({}, '', url.toString());
      form.submit();
    });
  })();
  // Mobile filter open/close handling (adds/removes is-filter-open on <1280px)
  (function () {
    const OPEN_ATTR = '[data-filter-open]';
    const CLOSE_ATTR = '[data-filter-close]';
    const CLOSE_ELEMENTS = document.querySelectorAll(CLOSE_ATTR);
    const BODY_CLASS = 'is-filter-open';
    const MOBILE_MAX = 1280; // matches xl breakpoint

    function isMobile() {
      return window.innerWidth < MOBILE_MAX;
    }

    function openFilters() {
      if (isMobile()) document.body.classList.add(BODY_CLASS);
    }

    function closeFilters() {
      document.body.classList.remove(BODY_CLASS);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest(OPEN_ATTR)) {
        e.preventDefault();
        openFilters();
      } else if (e.target.closest(CLOSE_ATTR)) {
        e.preventDefault();
        closeFilters();
      }
    });

    window.addEventListener('resize', function () {
      if (!isMobile()) {
        // Ensure class removed when transitioning to desktop
        closeFilters();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-slider"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var contentSlider = document.querySelectorAll('[data-slider="content"]');
    console.log('Content Slider Initialized', contentSlider);

    contentSlider.forEach(function (slider) {
      var el = slider.querySelector('[data-slider="image"]');
      if (!el) return;
      var elText = slider.querySelector('[data-slider="text"]');

      var autoplay = el.getAttribute('data-autoplay') === 'true';
      var duration = parseInt(el.getAttribute('data-duration')) || 2500;
      var pause = el.getAttribute('data-pause') === 'true';
      var nextButton = slider.querySelector('[data-next]');
      var prevButton = slider.querySelector('[data-prev]');
      var progressbar = slider.querySelector('[data-progressbar]');

      var textSwiper = new Swiper(elText, {
        spaceBetween: 0,
        slidesPerView: 1,
        watchSlidesProgress: true,
      });

      var swiperOptions = {
        slidesPerView: 'auto',
        spaceBetween: 0,
        watchSlidesProgress: true,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        scrollbar: {
          el: progressbar,
          draggable: true,
        },
      };

      if (autoplay) {
        swiperOptions.autoplay = {
          delay: duration,
          pauseOnMouseEnter: pause,
          disableOnInteraction: true,
          stopOnLastSlide: true,
        };
      }

      var imageSwiper = new Swiper(el, swiperOptions);

      // Use controller instead of thumbs
      imageSwiper.controller.control = textSwiper;
      textSwiper.controller.control = imageSwiper;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-testimonials"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var testimonialsCarousels = document.querySelectorAll('[data-carousel="testimonials"]');

    testimonialsCarousels.forEach(function (carousel) {
      var el = carousel.querySelector('[data-carousel="element"]');
      if (!el) return;

      var autoplay = el.getAttribute('data-autoplay') === 'true';
      var duration = parseInt(el.getAttribute('data-duration')) || 2500;
      var pause = el.getAttribute('data-pause') === 'true';
      var nextButton = carousel.querySelector('[data-next]');
      var prevButton = carousel.querySelector('[data-prev]');
      var progressbar = carousel.querySelector('[data-progressbar]');

      var swiperOptions = {
        slidesPerView: 'auto',
        spaceBetween: 0,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        scrollbar: {
          el: progressbar,
          draggable: true,
        },
      };

      if (autoplay) {
        swiperOptions.autoplay = {
          delay: duration,
          pauseOnMouseEnter: pause,
          disableOnInteraction: true,
          stopOnLastSlide: true,
        };
      }

      var testimonialsSwiper = new Swiper(el, swiperOptions);
      window.addEventListener('resize', function () {
        testimonialsSwiper.update();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  var menuItems = document.querySelectorAll('[data-menu-item]');
  if (menuItems.length > 0) {
    menuItems.forEach(function (menu) {
      var menuBanner = menu.querySelector('[data-menu-banner]');
      if (menuBanner) {
        menu.classList.add('has-menu-banner');
      }
    });
  }

  var cartToggleButton = document.querySelector('[data-cart-toggle]');
  var cartSection = document.querySelector('[data-ajax-cart-section]');
  var cartToggle = function () {
    if (document.body.classList.contains('is-sidecart-open')) {
      document.body.classList.remove('is-sidecart-open');
    } else {
      document.body.classList.add('is-sidecart-open');
    }
  };
  if (cartToggleButton) {
    cartToggleButton.addEventListener('click', cartToggle);
  }

  // Side search toggle
  var searchToggleButton = document.querySelector('[data-search-toggle]');
  var searchToggle = function () {
    document.body.classList.toggle('is-search-open');
  };
  if (searchToggleButton) {
    searchToggleButton.addEventListener('click', searchToggle);
  }

  // Mobile menu toggle
  var mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var mobileMenuClose = document.querySelector('[data-mobile-menu-close]');
  var mobileMenuBackdrop = document.querySelector('[data-mobile-menu-backdrop]');
  var siteHeader = document.querySelector('.site-header');

  // Localization Form
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        form: this.querySelector('form'),
        languageInput: this.querySelector('input[name="locale_code"]'),
        countryInput: this.querySelector('input[name="country_code"]'),
        currencyInput: this.querySelector('[data-currency-input]'),
        links: this.querySelectorAll('a[data-value]'),
        details: this.querySelector('details'),
      };

      this.elements.links.forEach((link) => link.addEventListener('click', this.onLinkClick.bind(this)));
      document.body.addEventListener('click', this.onBodyClick.bind(this));
    }

    onLinkClick(event) {
      event.preventDefault();
      const link = event.currentTarget;
      const name = link.dataset.name;
      const value = link.dataset.value;

      if (name === 'locale_code') {
        this.elements.languageInput.value = value;
      } else if (name === 'country_code') {
        this.elements.countryInput.value = value;
        if (link.dataset.currency) {
          this.elements.currencyInput.value = link.dataset.currency;
        }
        // Automatically select the first available language for the chosen country
        // if the current language is not supported.
        if (link.dataset.languages) {
          try {
            const raw = link.dataset.languages;
            const normalized = (raw || '').replace(/&quot;/g, '"').trim();
            if (normalized && normalized !== '[]' && normalized.startsWith('[') && normalized.endsWith(']')) {
              const availableLanguages = JSON.parse(normalized);
              if (
                Array.isArray(availableLanguages) &&
                availableLanguages.length > 0 &&
                !availableLanguages.includes(this.elements.languageInput.value)
              ) {
                this.elements.languageInput.value = availableLanguages[0];
              }
            }
          } catch (e) {
            console.error('Could not parse available languages for country:', value, e);
          }
        }
      }

      if (this.elements.form) {
        const formId = this.elements.form.dataset.formId;
        if (formId) {
          const formElement = document.getElementById(formId);
          if (formElement) {
            const formData = new FormData(formElement);
            fetch(formElement.action || '/localization', {
              method: 'POST',
              body: formData,
              credentials: 'same-origin',
            })
              .then((response) => {
                if (response.ok) {
                  window.location.reload();
                } else {
                  console.error('Failed to submit localization form');
                  // Fallback: force reload to let Shopify apply new market via server
                  window.location.reload();
                }
              })
              .catch(() => {
                // Network fallback
                window.location.reload();
              });
          }
        } else {
          this.elements.form.submit();
        }
      }
    }

    onBodyClick(event) {
      if (this.elements.details && !this.contains(event.target)) {
        this.elements.details.removeAttribute('open');
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  // Calculate header height and set mobile menu top position
  function calculateMobileMenuTopSpacing() {
    var siteHeader = document.querySelector('.site-header');
    var topBar = document.querySelector('.top-bar');
    var totalHeight = 0;

    if (siteHeader) {
      totalHeight += siteHeader.offsetHeight;
    }
    if (topBar) {
      totalHeight += topBar.offsetHeight;
    }

    if (mobileMenu) {
      mobileMenu.style.setProperty('--mobile-menu-padding-top', totalHeight + 'px');
    }
  }

  // Mobile menu functionality
  function openMobileMenu() {
    document.body.classList.add('is-mobile-menu-open');
    calculateMobileMenuTopSpacing();
  }

  function closeMobileMenu() {
    document.body.classList.remove('is-mobile-menu-open');
    // Close all open details elements
    var mobileMenuItems = document.querySelectorAll('[data-mobile-menu-item]');
    mobileMenuItems.forEach(function (item) {
      var details = item.querySelector('details');
      if (details && details.open) {
        details.open = false;
      }
    });
  }

  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', function () {
      if (document.body.classList.contains('is-mobile-menu-open')) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });
  }

  // Initialize mobile menu collapse functionality
  function initMobileMenuCollapse() {
    var mobileMenuItems = document.querySelectorAll('[data-mobile-menu-item]');

    mobileMenuItems.forEach(function (item) {
      var details = item.querySelector('details');
      if (details) {
        details.addEventListener('toggle', function () {
          // If this details is being opened
          if (details.open) {
            // Close all other details elements
            mobileMenuItems.forEach(function (otherItem) {
              if (otherItem !== item) {
                var otherDetails = otherItem.querySelector('details');
                if (otherDetails && otherDetails.open) {
                  otherDetails.open = false;
                }
              }
            });
          }
        });
      }
    });
  }

  // Recalculate on window resize
  window.addEventListener('resize', calculateMobileMenuTopSpacing);

  // Initial calculation
  calculateMobileMenuTopSpacing();

  // Initialize mobile menu collapse functionality
  initMobileMenuCollapse();

  // Close mobile menu when screen size changes to medium (md breakpoint)
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 768 && document.body.classList.contains('is-mobile-menu-open')) {
      closeMobileMenu();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metafield-compare"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var compareCarousels = document.querySelectorAll('[data-carousel="compare"]');

    compareCarousels.forEach(function (carousel) {
      var el = carousel.querySelector('[data-carousel="element"]');
      if (!el) return;

      var progressbar = carousel.querySelector('[data-progressbar]');

      var swiperOptions = {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: false,
        freeMode: {
          enabled: true,
          sticky: true,
        },
        scrollbar: {
          el: progressbar,
          draggable: true,
        },
      };

      var compareSwiper = new Swiper(el, swiperOptions);
    });

    // Add loading state to Add to Cart button when form is submitted
    var addToCartBtn = document.querySelectorAll('[data-add-to-cart]');
    var showSidecart = false;
    if (addToCartBtn) {
      addToCartBtn.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          if (!window.liquidAjaxCart?.init) return;
          // Ignore the click if Liquid Ajax Cart is processing a request
          if (window.liquidAjaxCart.processing) return;
          e.currentTarget.classList.add('is-cart-processing');
          showSidecart = true;
        });

        // Remove loading state when Ajax Cart request ends
        document.addEventListener('liquid-ajax-cart:request-end', function () {
          btn.classList.remove('is-cart-processing');
          if (!showSidecart) return;
          showSidecart = false;
          document.body.classList.add('is-sidecart-open');
          // setTimeout(() => {
          //   // Remove the class after 1 second
          //   document.body.classList.remove('is-sidecart-open');
          // }, 5000);
        });
      });
    }

    // Compare Items code here.
    (function () {
      const TYPE_GROUPS = ['current', 'image', 'name', 'price', 'button']; // single-instance per column equalization

      function resetHeights(nodes) {
        nodes.forEach((el) => {
          el.style.minHeight = '';
          el.style.height = '';
        });
      }

      function tallest(nodes) {
        let max = 0;
        nodes.forEach((el) => {
          const h = el.getBoundingClientRect().height;
          if (h > max) max = h;
        });
        return max;
      }

      function applyHeight(nodes, h) {
        nodes.forEach((el) => {
          el.style.minHeight = h + 'px';
        });
      }

      function equalizeFixedTypes(scope) {
        TYPE_GROUPS.forEach((type) => {
          const items = scope.querySelectorAll('[data-compare-item="' + type + '"]');
          if (!items.length) return;
          resetHeights(items);
          const h = tallest(items);
          if (h) applyHeight(items, h);
        });
      }

      function equalizeFeatureRows(scope) {
        // group by data-compare-row (mixed types: text, icon, tags)
        const rowNodes = scope.querySelectorAll('[data-compare-row]');
        if (!rowNodes.length) return;
        const groups = {};
        rowNodes.forEach((node) => {
          const k = node.getAttribute('data-compare-row');
          (groups[k] ||= []).push(node);
        });
        Object.keys(groups).forEach((k) => {
          const group = groups[k];
          resetHeights(group);
          const h = tallest(group);
          if (h) applyHeight(group, h);
        });
      }

      function equalizeAll(carousel) {
        if (!carousel) return;
        equalizeFixedTypes(carousel);
        equalizeFeatureRows(carousel);
      }

      function debounce(fn, wait) {
        let t;
        return function () {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, arguments), wait);
        };
      }

      const runAll = () => {
        document.querySelectorAll('[data-carousel="compare"]').forEach((c) => equalizeAll(c));
      };

      const debouncedRunAll = debounce(runAll, 120);

      window.addEventListener('resize', debouncedRunAll);

      // Initial & delayed executions
      requestAnimationFrame(() => {
        setTimeout(runAll, 60);
        setTimeout(runAll, 300); // second pass after images / fonts
      });

      // Image load reflow
      document.querySelectorAll('[data-carousel="compare"] img').forEach((img) => {
        if (!img.complete) {
          img.addEventListener('load', debouncedRunAll, { once: true });
        }
      });

      // Mutation observer for dynamic changes
      const mo = new MutationObserver(debouncedRunAll);
      document.querySelectorAll('[data-carousel="compare"]').forEach((c) => {
        mo.observe(c, { childList: true, subtree: true });
      });

      // Swiper hooks (if instances already exist or appear later)
      function attachSwiperHooks(swiper) {
        ['resize', 'slideChange', 'transitionEnd', 'update'].forEach((evt) => {
          swiper.on(evt, debouncedRunAll);
        });
      }

      // Existing swipers
      document.querySelectorAll('[data-carousel="element"]').forEach((el) => {
        if (el.swiper) attachSwiperHooks(el.swiper);
      });

      // Poll for late swiper init
      const poll = setInterval(() => {
        let pending = 0;
        document.querySelectorAll('[data-carousel="element"]').forEach((el) => {
          if (!el.swiper) pending++;
          else if (!el._compareHooked) {
            attachSwiperHooks(el.swiper);
            el._compareHooked = true;
          }
        });
        if (!pending) clearInterval(poll);
      }, 200);
      setTimeout(() => clearInterval(poll), 5000);
    })();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-compare"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var compareCarousels = document.querySelectorAll('[data-carousel="compare"]');

    compareCarousels.forEach(function (carousel) {
      var el = carousel.querySelector('[data-carousel="element"]');
      if (!el) return;

      var progressbar = carousel.querySelector('[data-progressbar]');

      var swiperOptions = {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: false,
        freeMode: {
          enabled: true,
          sticky: true,
        },
        scrollbar: {
          el: progressbar,
          draggable: true,
        },
      };

      var compareSwiper = new Swiper(el, swiperOptions);

      // Replaced previous highlight auto-slide logic with animated sequence
      (function setupHandSwipeSequence(swiper, rootEl, carouselRoot) {
        if (!swiper || !rootEl) return;
        var wrapper = rootEl.querySelector('.swiper-wrapper');
        var hand = carouselRoot.querySelector('[data-hand-swipe]');
        var svg = hand ? hand.querySelector('svg') : null;
        var RUN_LOCK = false;
        var SCALE_MS = 400;
        var WIGGLE_MS = 900;
        var SLIDE_MS = 600;

        function highlightIndex() {
          var hi = rootEl.querySelector('.swiper-slide .is-highlight');
          if (!hi) return -1;
          var slide = hi.closest('.swiper-slide');
          if (!slide) return -1;
          var slides = Array.prototype.slice.call(rootEl.querySelectorAll('.swiper-slide'));
          return slides.indexOf(slide);
        }
        function hasOverflow() {
          return wrapper && wrapper.scrollWidth > rootEl.clientWidth;
        }
        function resetHand() {
          if (!hand) return;
          hand.classList.add('opacity-0', 'invisible', 'scale-0');
          hand.classList.remove('opacity-100', 'visible', 'scale-100');
          if (svg) svg.classList.remove('animate-hand-wiggle');
        }
        function showHand() {
          if (!hand) return;
          hand.classList.remove('opacity-0', 'invisible', 'scale-0');
          hand.classList.add('opacity-100', 'visible', 'scale-100');
        }
        function hideHandRemove() {
          if (!hand) return;
          hand.classList.add('opacity-0', 'scale-0');
          setTimeout(function () {
            if (hand && hand.parentNode) hand.remove();
          }, 400);
        }
        function runSequence() {
          if (RUN_LOCK) return;
          var idx = highlightIndex();
          if (!hasOverflow() || idx <= 0) {
            // Nothing to do (either no overflow or highlight already first)
            hideHandRemove();
            return;
          }
          RUN_LOCK = true;
          resetHand();
          showHand();
          // After scale-in, wiggle
          setTimeout(function () {
            if (svg) svg.classList.add('animate-hand-wiggle');
            // After wiggle, slide
            setTimeout(function () {
              swiper.slideTo(idx, SLIDE_MS);
              // After slide & slight delay, hide hand
              setTimeout(function () {
                hideHandRemove();
                RUN_LOCK = false; // allow rerun on resize if still conditions
              }, SLIDE_MS + 150);
            }, WIGGLE_MS);
          }, SCALE_MS + 50);
        }

        // Trigger when in view
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                runSequence();
              }
            });
          },
          { threshold: 0.3 }
        );
        io.observe(rootEl);

        // Resize: re-run (debounced) if element still in view & not removed
        var rT;
        window.addEventListener('resize', function () {
          clearTimeout(rT);
          rT = setTimeout(function () {
            // If hand was removed, recreate? Only run if still overflow & highlight not first
            if (!document.body.contains(rootEl)) return;
            var rect = rootEl.getBoundingClientRect();
            if (rect.top < window.innerHeight && rect.bottom > 0) runSequence();
          }, 180);
        });

        // Safety initial fallback
        setTimeout(function () {
          var rect = rootEl.getBoundingClientRect();
          if (rect.top < window.innerHeight * 0.75 && rect.bottom > 0) runSequence();
        }, 600);
      })(compareSwiper, el, carousel);
      // End sequence logic
    });

    // Add loading state to Add to Cart button when form is submitted
    var addToCartBtn = document.querySelectorAll('[data-add-to-cart]');
    var showSidecart = false;
    if (addToCartBtn) {
      addToCartBtn.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          if (!window.liquidAjaxCart?.init) return;
          // Ignore the click if Liquid Ajax Cart is processing a request
          if (window.liquidAjaxCart.processing) return;
          e.currentTarget.classList.add('is-cart-processing');
          showSidecart = true;
        });

        // Remove loading state when Ajax Cart request ends
        document.addEventListener('liquid-ajax-cart:request-end', function () {
          btn.classList.remove('is-cart-processing');
          if (!showSidecart) return;
          showSidecart = false;
          document.body.classList.add('is-sidecart-open');
          // setTimeout(() => {
          //   // Remove the class after 1 second
          //   document.body.classList.remove('is-sidecart-open');
          // }, 5000);
        });
      });
    }

    // Compare Items code here.
    (function () {
      const TYPE_GROUPS = ['current', 'image', 'name', 'price', 'button']; // single-instance per column equalization

      function resetHeights(nodes) {
        nodes.forEach((el) => {
          el.style.minHeight = '';
          el.style.height = '';
        });
      }

      function tallest(nodes) {
        let max = 0;
        nodes.forEach((el) => {
          const h = el.getBoundingClientRect().height;
          if (h > max) max = h;
        });
        return max;
      }

      function applyHeight(nodes, h) {
        nodes.forEach((el) => {
          el.style.minHeight = h + 'px';
        });
      }

      function equalizeFixedTypes(scope) {
        TYPE_GROUPS.forEach((type) => {
          const items = scope.querySelectorAll('[data-compare-item="' + type + '"]');
          if (!items.length) return;
          resetHeights(items);
          const h = tallest(items);
          if (h) applyHeight(items, h);
        });
      }

      function equalizeFeatureRows(scope) {
        // group by data-compare-row (mixed types: text, icon, tags)
        const rowNodes = scope.querySelectorAll('[data-compare-row]');
        if (!rowNodes.length) return;
        const groups = {};
        rowNodes.forEach((node) => {
          const k = node.getAttribute('data-compare-row');
          (groups[k] ||= []).push(node);
        });
        Object.keys(groups).forEach((k) => {
          const group = groups[k];
          resetHeights(group);
          const h = tallest(group);
          if (h) applyHeight(group, h);
        });
      }

      function equalizeAll(carousel) {
        if (!carousel) return;
        equalizeFixedTypes(carousel);
        equalizeFeatureRows(carousel);
      }

      function debounce(fn, wait) {
        let t;
        return function () {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, arguments), wait);
        };
      }

      const runAll = () => {
        document.querySelectorAll('[data-carousel="compare"]').forEach((c) => equalizeAll(c));
      };

      const debouncedRunAll = debounce(runAll, 120);

      window.addEventListener('resize', debouncedRunAll);

      // Initial & delayed executions
      requestAnimationFrame(() => {
        setTimeout(runAll, 60);
        setTimeout(runAll, 300); // second pass after images / fonts
      });

      // Image load reflow
      document.querySelectorAll('[data-carousel="compare"] img').forEach((img) => {
        if (!img.complete) {
          img.addEventListener('load', debouncedRunAll, { once: true });
        }
      });

      // Mutation observer for dynamic changes
      const mo = new MutationObserver(debouncedRunAll);
      document.querySelectorAll('[data-carousel="compare"]').forEach((c) => {
        mo.observe(c, { childList: true, subtree: true });
      });

      // Swiper hooks (if instances already exist or appear later)
      function attachSwiperHooks(swiper) {
        ['resize', 'slideChange', 'transitionEnd', 'update'].forEach((evt) => {
          swiper.on(evt, debouncedRunAll);
        });
      }

      // Existing swipers
      document.querySelectorAll('[data-carousel="element"]').forEach((el) => {
        if (el.swiper) attachSwiperHooks(el.swiper);
      });

      // Poll for late swiper init
      const poll = setInterval(() => {
        let pending = 0;
        document.querySelectorAll('[data-carousel="element"]').forEach((el) => {
          if (!el.swiper) pending++;
          else if (!el._compareHooked) {
            attachSwiperHooks(el.swiper);
            el._compareHooked = true;
          }
        });
        if (!pending) clearInterval(poll);
      }, 200);
      setTimeout(() => clearInterval(poll), 5000);
    })();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var relatedProducts = document.querySelector('[data-related-products]');
    if (!relatedProducts) return;

    var dataUrl = relatedProducts.getAttribute('data-url');

    fetch(dataUrl)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const check = html.querySelector('.swiper');
        if (!check) {
          relatedProducts.innerHTML = '';
          return;
        }
        relatedProducts.classList.remove('hidden');

        const recommendations = html.querySelector('[data-related-products]');
        if (recommendations && recommendations.innerHTML.trim().length) {
          relatedProducts.innerHTML = recommendations.innerHTML;
          var productCarousels = relatedProducts.querySelectorAll('[data-carousel="product"]');

          productCarousels.forEach(function (carousel) {
            var el = carousel.querySelector('[data-carousel="element"]');
            if (!el) return;

            var autoplay = el.getAttribute('data-autoplay') === 'true';
            var duration = parseInt(el.getAttribute('data-duration')) || 2500;
            var pause = el.getAttribute('data-pause') === 'true';
            var nextButton = carousel.querySelector('[data-next]');
            var prevButton = carousel.querySelector('[data-prev]');
            var pagination = carousel.querySelector('[data-pagination]');
            var progressbar = carousel.querySelector('[data-progressbar]');

            var swiperOptions = {
              slidesPerView: 'auto',
              spaceBetween: 10,
              loop: false,
              navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
              },
              scrollbar: {
                el: progressbar,
                draggable: true,
              },
            };

            if (autoplay) {
              swiperOptions.autoplay = {
                delay: duration,
                pauseOnMouseEnter: pause,
                disableOnInteraction: true,
                stopOnLastSlide: true,
              };
            }

            var productSwiper = new Swiper(el, swiperOptions);
          });
        }
      })
      .catch((e2) => {
        console.error(e2);
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    /**
     * Executes a specific operation based on the provided selection.
     *
     * This function processes the current selection and performs actions
     * depending on the context or content of the selection.
     *
     * @param {Selection} selection - The current selection to be processed.
     * @returns {void}
     */
    function updateStickyOffset() {
      var gallery = document.querySelector('[data-product-gallery]');
      var info = document.querySelector('[data-product-info]');
      if (!gallery || !info) return;

      // Remove sticky classes if window width is less than 1024px
      if (window.innerWidth < 1024) {
        gallery.classList.remove('sticky', 'top-4');
        info.classList.remove('sticky', 'top-4');
        return;
      }

      var galleryHeight = gallery.offsetHeight;
      var infoHeight = info.offsetHeight;

      if (galleryHeight > infoHeight) {
        info.classList.add('sticky', 'top-4');
        gallery.classList.remove('sticky', 'top-4');
      } else {
        gallery.classList.add('sticky', 'top-4');
        info.classList.remove('sticky', 'top-4');
      }
    }

    window.addEventListener('resize', updateStickyOffset);
    updateStickyOffset();
    var gallery = document.querySelector('[data-gallery="product"]');
    if (gallery) {
      var galleryMain = gallery.querySelector('[data-gallery="main"]');
      var galleryThumbs = gallery.querySelector('[data-gallery="thumbs"]');
      if (galleryMain && galleryThumbs) {
        var swiperThumbs = new Swiper(galleryThumbs, {
          spaceBetween: 4,
          slidesPerView: 3,
          watchSlidesProgress: true,
        });

        var nextButton = gallery.querySelector('[data-next]');
        var prevButton = gallery.querySelector('[data-prev]');

        var swiperMain = new Swiper(galleryMain, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          thumbs: {
            swiper: swiperThumbs,
          },
        });
      }
    }

    // Handles the logic for selecting a product variant on the product page.
    // This may include updating the displayed product information, price, images, and availability
    // based on the user's selection of different product options (such as size or color).
    function updateSelectedVariant() {
      var checkedOptions = document.querySelectorAll('[data-variant-option]:checked');
      var selectedOptions = Array.from(checkedOptions).map((option) => option.value);

      // Find the variant that matches all selected options
      var matchingVariant = null;

      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        var variantOptions = [variant.option1, variant.option2, variant.option3].filter(Boolean);

        if (
          selectedOptions.length === variantOptions.length &&
          selectedOptions.every((option) => variantOptions.includes(option))
        ) {
          matchingVariant = variant;
          break;
        }
      }

      if (matchingVariant) {
        var selectedVariantInput = document.querySelector('[data-selected-variant]');
        if (selectedVariantInput) {
          selectedVariantInput.value = matchingVariant.id;
        }

        console.log('Matching Variant:', matchingVariant);

        // Update quantity input max value and reset quantity
        var quantityInput = document.querySelector('[data-quantity-input]');
        if (quantityInput) {
          if (matchingVariant.available) {
            quantityInput.value = 1;
            quantityInput.disabled = false;
            quantityInput.max = matchingVariant.inventory_quantity;

            // Enable quantity buttons
            var qtyMinusBtn = document.querySelector('[data-qty-minus]');
            var qtyPlusBtn = document.querySelector('[data-qty-plus]');
            if (qtyMinusBtn) qtyMinusBtn.disabled = false;
            if (qtyPlusBtn) qtyPlusBtn.disabled = false;

            // Enable add to cart button
            var addToCartBtn = document.querySelector('[data-add-to-cart]');
            if (addToCartBtn) {
              addToCartBtn.disabled = false;
              addToCartBtn.classList.remove('is-unavailable');
            }
          } else {
            quantityInput.value = 1;
            quantityInput.disabled = true;

            // Disable quantity buttons
            var qtyMinusBtn = document.querySelector('[data-qty-minus]');
            var qtyPlusBtn = document.querySelector('[data-qty-plus]');
            if (qtyMinusBtn) qtyMinusBtn.disabled = true;
            if (qtyPlusBtn) qtyPlusBtn.disabled = true;

            // Disable add to cart button
            var addToCartBtn = document.querySelector('[data-add-to-cart]');
            if (addToCartBtn) {
              addToCartBtn.disabled = true;
              addToCartBtn.classList.add('is-unavailable');
            }
          }
        }

        // Update variant price and render tax label using data-tax-* attributes (matching tax.liquid)
        var priceElement = document.querySelector('[data-product-price]');
        if (priceElement && matchingVariant.price) {
          var currencyIso = priceElement.getAttribute('data-iso') || priceElement.dataset.iso || 'USD';
          var locale = document.documentElement.getAttribute('lang') || navigator.language || 'en';

          var nf = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyIso,
            currencyDisplay: 'narrowSymbol',
          });

          var formattedPrice = nf.format(matchingVariant.price / 100);
          var html = '';

          if (matchingVariant.compare_at_price && matchingVariant.compare_at_price > matchingVariant.price) {
            var formattedComparePrice = nf.format(matchingVariant.compare_at_price / 100);
            html = `
              <span class="font-bold">${formattedPrice} ${currencyIso}</span>
              <del class="font-normal line-through text-slate-400">${formattedComparePrice} ${currencyIso}</del>
            `;
          } else {
            html = `
              <span class="font-bold">${formattedPrice} ${currencyIso}</span>
            `;
          }

          // Use a single tax label
          var taxLabel = priceElement.getAttribute('data-tax-label') || priceElement.dataset.taxLabel || '';
          var taxHtml = '<span class="text-xs font-normal opacity-60 tracking-tight">' + taxLabel + '</span>';

          priceElement.innerHTML = html + taxHtml;
        }

        /**
         * Updates the main product image gallery and SKU display based on the selected product variant.
         *
         * - If a Swiper gallery instance (`swiperMain`) exists, this code locates the slide that corresponds
         *   to the selected variant by searching for a slide whose `data-variants` attribute contains the
         *   matching variant's ID. If found, it navigates the gallery to that slide, ensuring the correct
         *   variant image is shown.
         *
         * - It then updates the SKU display element (`[data-product-sku]`) with the SKU of the selected variant.
         *   If the variant has a SKU, it is displayed; otherwise, the SKU field is cleared.
         *
         * This logic ensures that both the product image and SKU information are synchronized with the user's
         * variant selection, providing a seamless and accurate product browsing experience.
         */
        if (swiperMain) {
          var slides = document.querySelectorAll('[data-variants]');
          var targetSlideIndex = -1;

          slides.forEach(function (slide, index) {
            var variantIds = slide.getAttribute('data-variants').split(',');
            if (variantIds.includes(matchingVariant.id.toString())) {
              targetSlideIndex = index;
            }
          });

          if (targetSlideIndex !== -1) {
            swiperMain.slideTo(targetSlideIndex);
          }
        }

        // Update SKU display
        var skuElement = document.querySelector('[data-product-sku]');
        if (skuElement && matchingVariant.sku) {
          skuElement.textContent = matchingVariant.sku;
        } else if (skuElement) {
          skuElement.textContent = '';
        }
      }
    }

    // Add event listeners to variant options
    document.querySelectorAll('[data-variant-option]').forEach(function (option) {
      option.addEventListener('change', updateSelectedVariant);
    });

    // Initialize on page load
    updateSelectedVariant();

    // Add loading state to Add to Cart button when form is submitted
    var addToCartBtn = document.querySelectorAll('[data-add-to-cart]');
    var showSidecart = false;
    if (addToCartBtn) {
      addToCartBtn.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          if (!window.liquidAjaxCart?.init) return;
          // Ignore the click if Liquid Ajax Cart is processing a request
          if (window.liquidAjaxCart.processing) return;
          e.currentTarget.classList.add('is-cart-processing');
          showSidecart = true;
        });

        // Remove loading state when Ajax Cart request ends
        document.addEventListener('liquid-ajax-cart:request-end', function () {
          btn.classList.remove('is-cart-processing');
          if (!showSidecart) return;
          showSidecart = false;
          document.body.classList.add('is-sidecart-open');
          // setTimeout(() => {
          //   // Remove the class after 1 second
          //   document.body.classList.remove('is-sidecart-open');
          // }, 5000);
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["side-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function sideCartScripts() {
      var cartSection = document.querySelector('[data-ajax-cart-section]');
      var overlay = document.querySelector('[data-ajax-cart-overlay]');
      var closeButton = document.querySelector('[data-ajax-cart-close]');

      // Close side cart when clicking outside
      document.body.addEventListener('click', function (event) {
        if (event.target.matches('[data-ajax-cart-toggle]')) {
          event.preventDefault();
          document.body.classList.toggle('is-sidecart-open');
        }
      });

      // Toggle side cart visibility
      if (overlay) {
        overlay.addEventListener('click', function () {
          document.body.classList.remove('is-sidecart-open');
        });
      }
      if (closeButton) {
        closeButton.addEventListener('click', function () {
          document.body.classList.remove('is-sidecart-open');
        });
      }

      // Add loading state to Add to Cart button when form is submitted
      var addToCartBtn = document.querySelectorAll('[data-add-to-cart]');
      var showSidecart = false;
      if (addToCartBtn) {
        addToCartBtn.forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            if (!window.liquidAjaxCart?.init) return;
            // Ignore the click if Liquid Ajax Cart is processing a request
            if (window.liquidAjaxCart.processing) return;
            e.currentTarget.classList.add('is-cart-processing');
            showSidecart = true;
          });

          // Remove loading state when Ajax Cart request ends
          document.addEventListener('liquid-ajax-cart:request-end', function () {
            btn.classList.remove('is-cart-processing');
          });
        });
      }
    }
    sideCartScripts();
    document.addEventListener('liquid-ajax-cart:queue-end', function () {
      sideCartScripts();
    });

    const fgEvents = ['bogos:discount-added', 'bogos:bundle:added'];
    fgEvents.forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        window.liquidAjaxCart.update();
        setTimeout(() => {
          document.body.classList.add('is-sidecart-open');
        }, 3000);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["side-search"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function sideSearchScripts() {
      if (document.body.hasAttribute('data-side-search-initialized')) return;
      document.body.setAttribute('data-side-search-initialized', 'true');

      const searchSection = document.querySelector('[data-search-section]');
      const overlay = document.querySelector('[data-search-overlay]');
      const closeButton = document.querySelector('[data-search-close]');
      const form = document.querySelector('[data-search-form]');
      const searchInput = document.querySelector('[data-search-input]');
      const resultWrapper = document.querySelector('[data-search-result]');
      const viewAllLabel = resultWrapper.dataset.labelViewall;
      const resultsLabel = resultWrapper.dataset.labelResult;
      let keyUp = Number(searchInput.dataset.keyUp);
      if (!Number.isFinite(keyUp)) {
        keyUp = 3; // Default to 3 if not set or invalid
      }

      document.body.addEventListener('click', function (event) {
        if (event.target.matches('[data-search-toggle]')) {
          event.preventDefault();
          document.body.classList.toggle('is-search-open');
        }
      });

      if (overlay) {
        overlay.addEventListener('click', function () {
          document.body.classList.remove('is-search-open');
        });
      }
      if (closeButton) {
        closeButton.addEventListener('click', function () {
          document.body.classList.remove('is-search-open');
        });
      }

      if (searchInput && form && resultWrapper) {
        let activeController = null;

        const STATE_CLASSES = [
          'is-search-loading',
          'is-search-loaded',
          'is-search-success',
          'is-search-error',
          'is-term-short',
          'is-default',
        ];

        function applyState(stateClass, { busy = false } = {}) {
          STATE_CLASSES.forEach((c) => searchSection.classList.remove(c));
          if (stateClass) {
            searchSection.classList.add(stateClass);
          }
          if (busy) {
            searchSection.setAttribute('aria-busy', 'true');
          } else {
            searchSection.removeAttribute('aria-busy');
          }
        }

        function setShortState() {
          resultWrapper.innerHTML = '';
          if (!searchInput.value.trim()) {
            applyState('is-default');
          } else {
            applyState('is-term-short');
          }
        }

        function startLoading() {
          applyState('is-search-loading', { busy: true });
        }

        function finishLoading(hasResults) {
          if (hasResults) {
            applyState('is-search-success');
          } else {
            applyState('is-search-error');
          }
        }

        // Initialize with default state when drawer opens / script loads
        setShortState();

        searchInput.addEventListener('keyup', (e2) => {
          const value = e2.target.value.trim();

          if (value.length < keyUp) {
            if (activeController) {
              activeController.abort();
              activeController = null;
            }
            setShortState();
            return;
          }

          if (activeController) activeController.abort();
          activeController = new AbortController();

          startLoading();

          fetch(
            '/search/suggest?q=' +
              encodeURIComponent(value) +
              '&resources[type]=product&resources[options][fields]=title,product_type,vendor,variants.sku' +
              '&section_id=predictive-search&view_all_label=' +
              encodeURIComponent(viewAllLabel) +
              '&results_label=' +
              encodeURIComponent(resultsLabel),
            {
              signal: activeController.signal,
            }
          )
            .then((response) => {
              if (!response.ok) throw new Error(response.status);
              return response.text();
            })
            .then((text) => {
              const parsed = new DOMParser().parseFromString(text, 'text/html');
              const source = parsed.querySelector('#shopify-section-predictive-search');
              if (source) {
                resultWrapper.innerHTML = source.innerHTML;
                const button = resultWrapper.querySelector('[data-search-button]');
                const spanViewAll = resultWrapper.querySelector('[data-label-viewall]');
                if (button) {
                  // ensure label applied (fallback if section didn't use param)
                  if (!spanViewAll.textContent.trim()) {
                    spanViewAll.textContent = viewAllLabel;
                  } else {
                    spanViewAll.textContent = viewAllLabel;
                  }
                  button.addEventListener(
                    'click',
                    (e3) => {
                      e3.preventDefault();
                      form.submit();
                    },
                    { once: true }
                  );
                }
                const hasResults = resultWrapper.textContent.trim().length > 0;
                finishLoading(hasResults);
              } else {
                resultWrapper.innerHTML = '';
                finishLoading(false);
              }
            })
            .catch((error) => {
              if (error.name === 'AbortError') return;
              console.warn('Predictive search error:', error);
              resultWrapper.innerHTML = '';
              finishLoading(false);
            });
        });
      }

      // Unified Add-to-Cart handlers for search (supports multiple and dynamic buttons)
      (function setupSearchAddToCartHandlers() {
        var lastProcessingBtn = null;
        var canOpenSideCart = false;

        // Delegate click to capture current and future buttons
        document.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-add-to-cart-search]');
          if (!btn) return;
          if (btn.disabled || btn.classList.contains('is-unavailable')) return;

          lastProcessingBtn = btn;
          btn.classList.add('is-cart-processing');
          canOpenSideCart = true;
        });

        function clearProcessingState() {
          if (!canOpenSideCart) return;
          if (lastProcessingBtn) {
            lastProcessingBtn.classList.remove('is-cart-processing');
            lastProcessingBtn = null;
          }
          // Ensure any leftover buttons are reset (in case of DOM swaps)
          document.querySelectorAll('[data-add-to-cart-search].is-cart-processing').forEach(function (b) {
            b.classList.remove('is-cart-processing');
          });

          // Only open side cart if it was triggered by an add-to-cart action
          document.body.classList.remove('is-search-open');
          document.body.classList.add('is-sidecart-open');
          console.log('Side cart opened from search add-to-cart action');

          document.body.classList.remove('is-search-open');
          document.body.classList.add('is-sidecart-open');

          canOpenSideCart = false;
        }

        // Remove loading state when Ajax Cart request ends (success or failure)
        document.addEventListener('liquid-ajax-cart:request-end', clearProcessingState);
        document.addEventListener('liquid-ajax-cart:error', clearProcessingState);
      })();
    }

    sideSearchScripts();
  });

  } catch(e) { console.error(e); }
})();
})();
